import React from 'react';

import './Header5.css';

export default function Header5({ children }) {
    return <h5 className="Header5">{children}</h5>;
}
